import numeral from 'numeral';
import { cloneDeep } from 'lodash';
import { message } from 'antd';
export const checkMmu = (mmuAttributeList) => {
  // 是否有必填的错误提示
  var requireErrMsg = '';
  mmuAttributeList.forEach(function (attribute) {
    if (attribute.hasCustomize) {
      var categoryAttributeValueItem = attribute?.categoryAttributeValueList[0];
      var { attributeValue } = categoryAttributeValueItem;
      if ((attributeValue === undefined || attributeValue === '') && attribute.hasRequired) {
        requireErrMsg = attribute.attributeName + '不能为空';
      } else if (
        attribute.hasRequired &&
        attribute.attributeName === '容重' &&
        (Number(attributeValue) > 10000 || Number(attributeValue) < 1000)
      ) {
        // 容重需要单独校验取值范围,此处没有唯一key判断,先取attributeName作为key值
        requireErrMsg = '容重数值请控制在1000KG/M³ 至 10000KG/M³以内';
      }
    }
  });
  if (requireErrMsg) {
    message.error(requireErrMsg);
    return false;
  }

  return true;
};

export const formatNumber = function (value, fmt) {
  // eslint-disable-next-line no-param-reassign
  value = +value;
  if (!Number.isFinite(value)) {
    return '';
  }
  return numeral(value).format(fmt);
};

export const buildSku = (skuDetail, shopQuantity) => {
  // 是否有必填的错误提示
  var requireErrMsg = '';
  var skuDetailClone = cloneDeep(skuDetail);
  var commentArr = [];
  var { attributeList } = skuDetailClone;
  attributeList.forEach((attribute) => {
    attribute.categoryAttributeValueList = attribute.categoryAttributeValueList.filter(
      (categoryAttribute) => categoryAttribute.active,
    );
  });
  var mmuAttributeList = skuDetailClone.mmuAttributeList.map((attribute) => {
    if (!attribute.hasCustomize) {
      attribute.categoryAttributeValueList = attribute.categoryAttributeValueList.filter(
        (categoryAttribute) => {
          if (categoryAttribute.active) {
            commentArr.push(categoryAttribute.attributeValue);
          }
          return categoryAttribute.active;
        },
      );
    } else {
      var categoryAttributeValueItem = attribute?.categoryAttributeValueList[0];
      var { attributeValue } = categoryAttributeValueItem;
      if (attributeValue !== undefined && attributeValue !== '') {
        if (
          attribute.hasRequired &&
          attribute.attributeName === '容重' &&
          (Number(attributeValue) > 10000 || Number(attributeValue) < 1000)
        ) {
          // 容重需要单独校验取值范围,此处没有唯一key判断,先取attributeName作为key值
          requireErrMsg = '容重数值请控制在1000KG/M³ 至 10000KG/M³以内';
          return;
        }
        categoryAttributeValueItem.active = true;
        commentArr.push(
          categoryAttributeValueItem.prefix +
            categoryAttributeValueItem.attributeValue +
            categoryAttributeValueItem.suffix,
        );
      } else {
        if (attribute.hasRequired && !requireErrMsg) {
          requireErrMsg = attribute.attributeName + '不能为空';
        }
      }
    }
    return attribute;
  });

  if (requireErrMsg) {
    message.error(requireErrMsg);
    return false;
  }

  return {
    sysNo: skuDetail.sysNo,
    name: skuDetail.name,
    brandSysNo: skuDetail.brandSysNo,
    brandName: skuDetail.brandName,
    salesPrice: skuDetail.salesPrice,
    excludeTaxPrice: skuDetail.excludeTaxPrice,
    netPriceWithTax: skuDetail.netPriceWithTax,
    netPriceWithoutTax: skuDetail.netPriceWithoutTax,
    netPriceSource: skuDetail.netPriceSource,
    priceWithTax: skuDetail.priceWithTax,
    priceWithOutTax: skuDetail.priceWithOutTax,
    quoteMode: skuDetail.quoteMode,
    shopQuantity: shopQuantity,
    usePart: skuDetail.usePart ? skuDetail.usePart.slice(0, 200) : skuDetail.usePart,
    comment: commentArr.join('，') ? commentArr.join('，').slice(0, 200) : commentArr.join('，'),
    attributeList: attributeList,
    mmuAttributeList: mmuAttributeList,
    taxRate: skuDetail.taxRate,
    unitName: skuDetail.unitName,
    unitSysNo: skuDetail.unitSysNo,
    buyStep: skuDetail.buyStep,
  };
};
